export const setupBreadcrumbs = () => {
  const breadcrumb = document.querySelector('.sf-breadscrumb') as HTMLElement;

  if (breadcrumb) {
    breadcrumb.classList.add('loaded');

    document.querySelector('.social-share-container')?.classList.add('loaded');

    // $("ul.sf-breadscrumb li:last-child a").text()
    const menuItemText = breadcrumb.querySelector('li:last-child')?.textContent;
    document.querySelectorAll('.main-nav ul li').forEach((li: Element) => {
      const liElement = li as HTMLUListElement;
      if (liElement.querySelector('span')?.textContent?.toLowerCase() == menuItemText) {
        liElement.classList.add('active');
      }
    });
  }
};
